var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParameterActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 12,
    viewBox: "0 0 24 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.72827 11.061C7.42997 10.9827 7.70898 10.124 7.35146 9.14315C6.99393 8.16231 6.13526 7.43073 5.43356 7.50912C4.73186 7.58751 4.45285 8.44618 4.81038 9.42702C5.1679 10.4079 6.02657 11.1394 6.72827 11.061Z",
    stroke: "#0A7F8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.6692 1.14208C15.9675 1.22046 15.6885 2.07913 16.046 3.05997C16.4035 4.04081 17.2622 4.77239 17.9639 4.69401C18.6656 4.61562 18.9446 3.75695 18.5871 2.77611C18.2296 1.79527 17.3709 1.06369 16.6692 1.14208Z",
    stroke: "#0A7F8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.9538 3.92315L15.4175 5.66185C15.0539 6.84068 14.8719 7.43068 14.4611 7.60438C14.3002 7.67369 14.1174 7.69532 13.9217 7.66821C13.4245 7.60196 12.8505 7.10254 11.7024 6.10148C10.5547 5.10148 9.98029 4.60099 9.48313 4.53474C9.28776 4.50844 9.10495 4.53008 8.94369 4.59857C8.53288 4.77227 8.35051 5.3612 7.98729 6.54111L7.45099 8.27981",
    stroke: "#0A7F8F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParameterActive);
export default __webpack_public_path__ + "static/media/parameter_active.ba3d68311918be58e65848b7dd50e2bf.svg";
export { ForwardRef as ReactComponent };